// Module
var code = "<template><compose class=\"page-brand-site column grow-xs-1 min-height-0\" view-model=\"../brand/dialogs/widget-branding-dialog\"></compose></template>";
// Exports
module.exports = code;